import React, { useEffect } from "react";

export default function Redirect(props) {
  const decodedString = atob(decodeURIComponent(props.token));
  const searchParams = new URLSearchParams(decodedString);
  const action = searchParams.get("action");

  useEffect(() => {
    window.location.href = action;
  }, [action]);
  return <></>;
}
